import * as Sentry from '@sentry/react';

import {
  isJestRuntime,
  isTestRuntime,
  sentryDsn,
  sentryEnvironment,
} from 'shared/constants/envVariables';

const sentryEnabled = Boolean(sentryDsn) && !isJestRuntime && !isTestRuntime;

if (sentryEnabled) {
  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnvironment,
    tracesSampleRate: 0,
  });
}
